import { StyleSystemProps, styled, Box } from '@withjoy/joykit';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';
import { pxToRem } from '@withjoy/joykit/theme';

export const StyledContainer = styled(Box)``;
export const StyledContents = styled(Box)``;
export const StyledTitle = styled(Box)``;
export const TopCategoryProductsCarouselContainer = styled(Box)``;

const containerStyles: StyleSystemProps = {
  width: '100%',
  height: '100%',
  zIndex: 0,
  position: 'relative',
};

const contentsStyles: StyleSystemProps = {
  height: '100%',
  paddingBottom: 6,
  zIndex: 10,
  position: 'relative',
};

const skeletonContentsStyles: StyleSystemProps = {
  height: '100%',
  backgroundColor: 'mono1',
  paddingBottom: 6,
};
const topCategoryProductsCarouselStyles: StyleSystemProps = {
  marginTop: [pxToRem(58), null, pxToRem(130)],
};
const titleStyles: StyleSystemProps = {
  marginTop: pxToRem(96),
  maxWidth: pxToRem(566),
  color: 'white',
};

const mediaContainerStyles: StyleSystemProps = {
  position: 'absolute',
  top: '0px',
  left: '0px',
  right: '0px',
  height: '100%',
};

const mediaLayerStyles: StyleSystemProps = {
  ...mediaContainerStyles,
  height: '100%',
  width: '100%',
};

const gradientStyles: StyleSystemProps = {
  ...mediaLayerStyles,
  zIndex: 3,
  background:
    'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 47.56%, rgba(0, 0, 0, 0.60) 63.74%, #000 85.70%), linear-gradient(153deg, rgba(0, 0, 0, 0.60) 1.82%, rgba(0, 0, 0, 0.00) 23.66%), linear-gradient(180deg, rgba(0, 0, 0, 0.08) 41.77%, rgba(0, 0, 0, 0.40) 55.73%)',
};

const backgroundVideoStyles: StyleSystemProps = {
  ...mediaLayerStyles,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  zIndex: 2,
};

const backgroundImageStyles = ($backgroundImageUrl: Maybe<string>): StyleSystemProps => ({
  ...mediaLayerStyles,
  zIndex: 1,
  backgroundImage: `url("${$backgroundImageUrl || ''}")`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
});

const backgroundVideoContainerStyles: CSSObject = {
  position: 'relative',
  height: '100%',
  overflow: 'hidden',
  padding: '0',
  ['& iframe']: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    // width will depend on the video aspect ratio
    width: '177vh',
    height: '62.25vw',
    minHeight: '100%',
    minWidth: '100%',
  },
};

export const styles = {
  container: containerStyles,
  contents: contentsStyles,
  skeletonContents: skeletonContentsStyles,
  topCategoryProductsCarousel: topCategoryProductsCarouselStyles,
  title: titleStyles,
  mediaContainer: mediaContainerStyles,
  gradient: gradientStyles,
  backgroundVideo: backgroundVideoStyles,
  backgroundImage: backgroundImageStyles,
  backgroundVideoContainer: backgroundVideoContainerStyles,
};
